import filter from 'lodash/fp/filter';

export const filterOutUndefinedIds = filter(({ id }) => id !== undefined);
